import {configureStore} from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import {combineReducers} from "redux";
import { persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';

import loginReducer from '../pages/Login/redux/loginSlice';
import loginLoadingReducer from '../pages/Login/redux/loginLoadingSlice';

const reducers = combineReducers({
    ldata: loginReducer,
    loldata: loginLoadingReducer
});

const persistConfig = {
    key: 'root',
    storage
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk]
});

export default store;